export default "__VITE_ASSET__4ASzttBV__"